import Vue from 'vue'
import Vuex from 'vuex'
import Api from '@/ApiService'
import Cookies from 'js-cookie'
import CONFIG from '../config'
import LOCATION_MANAGERS from './helpers/locationManagers'
import VueJsonp from 'vue-jsonp'

Vue.use(Vuex)
Vue.use(VueJsonp)

const DEFAULT_AUTH_COOKIE = 'auth_hash_cookie'

export default new Vuex.Store({
  state: {
    inited: false,
    user: null,
    history: null,
    stores: null,
    tags: null,
    gifts: null,
    config: null,
    badges: null,
    quests: null,
    vars: null,
    p2pTypes: ['default', 'm2p', 'p2p', 'edu'],
    p2pConfig: {},
    auth_hash: null

  },
  getters: {
    isInited: state => state.inited,

    currentUser: state => state.user && state.user.user,
    currentPoints: state => state.user && state.user.user_points && state.user.user_points.confirmed,
    currentHistory: state => state.history,
    currentTags: state => state.tags,

    storeList: state => state.stores && state.stores.list,
    storeCategories: state => state.stores && state.stores.categories,

    currentUserStores: (state, getters) => {
      return getters.storeList && getters.currentTags && getters.storeList.filter(store => ~getters.currentTags.map(item => item.tag).indexOf(store.name))
    },
    currentUserCategories: (state, getters) => {
      return getters.storeCategories && getters.currentTags && getters.storeCategories.filter(category => ~getters.currentTags.map(item => item.tag).indexOf(category))
    },

    remoteConfig: state => state.config,


    city: (state, getters) => {
      let cityOverride = getters.remoteConfig
        && getters.remoteConfig.cityOverride
        && getters.remoteConfig.cityOverride.find(city => city.email == getters.currentUser.email)
      return (cityOverride && cityOverride.city) ||
        (
          (getters.currentVars &&
            getters.currentVars.find((x) => x.name == "City") &&
            getters.currentVars.find((x) => x.name == "City").value) ||
          "No City"
        );
    },

    giftList: (state, getters) => {
      let gifts = state.gifts && Object.assign([], state.gifts);
      gifts = gifts && gifts.map((elem) => {
        let data = JSON.parse(elem.descr);
        elem.description = data && data.description;
        elem.image = data && data.image.replace('sailplays3.cdnvideo.ru', 'sailplays3-ua.cdnvideo.net');
        return elem;
      })
      gifts = gifts && gifts.filter((gift) => {
        // Remove metadata from the gift name for comparison
        const cleanGiftName = gift.name.replace(/<[^>]*>/g, '').trim();
      
        if (
          getters.remoteConfig && getters.remoteConfig["giftFilterByManagerExcept"] &&
          cleanGiftName in getters.remoteConfig["giftFilterByManagerExcept"]
        ) {
          if (
            !getters.remoteConfig["giftFilterByManagerExcept"][
              cleanGiftName
            ].includes(getters.locationManager)
          ) {
            return false;
          }
        }

        if (
          getters.remoteConfig && getters.remoteConfig["giftFilterByLocationExcept"] &&
          cleanGiftName in getters.remoteConfig["giftFilterByLocationExcept"]
        ) {
          if (
            !getters.remoteConfig["giftFilterByLocationExcept"][
              cleanGiftName
            ].includes(getters.city)
          ) {
            return false;
          }
        }
        if (
          getters.remoteConfig &&
          getters.remoteConfig["giftFilterByManager"] &&
          getters.locationManager in getters.remoteConfig["giftFilterByManager"]
        ) {
          if (
            getters.remoteConfig && getters.remoteConfig["giftFilterByManager"][
              getters.locationManager
            ].includes(cleanGiftName)
          ) {
            return false;
          }
        }
        if (
          getters.remoteConfig &&
          getters.remoteConfig["giftFilterByLocation"] &&
          getters.city in getters.remoteConfig["giftFilterByLocation"]
        ) {
          if (
            getters.remoteConfig["giftFilterByLocation"][getters.city].includes(
              cleanGiftName
            )
          ) {
            return false;
          }
        }
        return true;
      });
      
      if (getters.currentTags && getters.currentTags.find((t) => t.tag === 'Location Russia')) {
        gifts = gifts.filter(gift => getters.remoteConfig.charityGifts.includes(gift.id))
      }
      return gifts || []
    },
    nextGifts: (state, getters) => {
      return getters.currentUser && getters.giftList && getters.giftList.sort((a, b) => parseInt(a.points) - parseInt(b.points)).filter(item => item.points > getters.currentPoints && getters.remoteConfig && getters.remoteConfig.tabCategories['default'].includes(item.category))
    },
    nextGift: (state, getters) => getters.nextGifts && getters.nextGifts[0],

    badgeList: state => state.badges,
    questList: state => state.quests,

    currentVars: state => state.vars,
    locationManager: (state) => {
      let city = state.vars && state.vars.find(x => x.name == 'City') && state.vars.find(x => x.name == 'City').value
      if (city) {
        let locationManager = LOCATION_MANAGERS[city]
        if (locationManager) return locationManager
      }
      return "loyalty@luxoft.com"
    },
    p2pConfig: state => state.p2pConfig,

    isItPlatformaUser: state => state.tags && state.tags.find(v => v.tag === "IT-Platforma out of domain" || v.tag === "IT-Platforma")

  },
  mutations: {
    setAuthHash(state, auth_hash) {
      state.auth_hash = auth_hash
    },
    ready(state) {
      state.inited = true
    },
    updateUserInfo(state, user) {
      state.user = user
    },
    updateHistory(state, history) {
      state.history = history
    },
    updateTags(state, tags) {
      state.tags = tags
    },
    updateVars(state, vars) {
      state.vars = vars;
    },
    updateStores(state, data) {
      state.stores = data
    },
    updateGifts(state, gifts) {
      state.gifts = gifts
    },
    updateConfig(state, config) {
      state.config = config
    },
    updateBadges(state, badges) {
      state.badges = badges
    },
    updateQuests(state, quests) {
      state.quests = quests
    },
    updateP2pConfig(state, config) {
      Vue.set(state.p2pConfig, config.type, config)
    }

  },
  actions: {

    init() {
      return Api.init()
    },

    fetchUser({
      commit
    }, notCommit) {
      return new Promise((resolve, reject) => {
        Api.userInfo().then(res => {
          if (!notCommit)
            commit('updateUserInfo', res)
          resolve(res)
        }, reject)
      })
    },

    fetchHistory({
      commit
    }) {
      return new Promise((resolve, reject) => {
        Api.userHistory().then(res => {
          commit('updateHistory', res)
          resolve(res)
        }, reject)
      })
    },

    fetchStores({
      commit
    }) {
      return new Promise((resolve, reject) => {
        fetch(CONFIG.stores_url || 'stores.json')
          .then(r => r.json(), reject)
          .then(json => {
            commit('updateStores', json)
            resolve(json)
          }, reject)
      })
    },

    fetchTags({
      commit
    }, notCommit) {
      return new Promise((resolve, reject) => {
        Api.userTags().then(res => {
          if (!notCommit) {
            commit('updateTags', res.tags)
          }
          resolve(res)
        }, reject)
      })
    },

    fetchVars({
      commit
    }, notCommit) {
      return new Promise((resolve, reject) => {
        Api.userVars().then(res => {
          if (!notCommit) {
            commit('updateVars', res.vars) //TODO
          }
          resolve(res)
        }, reject)
      })
    },

    fetchCity({
      commit
    }, notCommit) {
      return new Promise((resolve, reject) => {
        Api.userCity().then(res => {
          if (!notCommit) {
            commit('updateCity', res.value) //TODO
          }
          resolve(res)
        }, reject)
      })
    },

    fetchGifts({
      commit
    }) {
      return new Promise((resolve, reject) => {
        Api.giftsList().then(res => {
          if (res && res.length) {
            let gifts = res.map(item => {
              try {
                item.data = JSON.parse(item.descr)
              } catch (e) { };
              return item
            })
            commit('updateGifts', gifts)
          }
          resolve(res)
        }, reject)
      })
    },

    fetchConfig({
      commit
    }) {
      return new Promise((resolve, reject) => {
        Api.config().then(res => {
          commit('updateConfig', res.config.config)
          resolve(res)
        }, reject)
      })
    },

    fetchQuests({
      commit
    }) {
      return new Promise((resolve, reject) => {
        Promise.all([Api.loadActions(), Api.loadCustomActions()]).then(res => {
          let system = res.find(item => !Array.isArray(item)).actions
          let custom = res.find(item => Array.isArray(item))
          let quests = [...system, ...custom]
          commit('updateQuests', quests)
          resolve(quests)
        }, reject)
      })
    },

    userUpdate({
      commit
    }, params) {
      return Api.userUpdate(params)
    },

    changeAvatar({
      commit
    }, file) {
      return Api.changeAvatar(file)
    },

    changeTags({
      commit
    }, tags) {
      return new Promise((resolve, reject) => {
        if (tags.remove && tags.remove.length) {
          Api.removeTags(tags.remove, tags.auth_hash).then(() => {
            if (tags.add && tags.add.length) {
              Api.addTags(tags.add, tags.auth_hash).then(resolve, reject)
            } else {
              resolve()
            }
          }, reject)
        } else if (tags.add && tags.add.length) {
          Api.addTags(tags.add).then(resolve, reject)
        } else {
          resolve()
        }
      })
    },

    fetchBadges({ commit }) {
      return new Promise((resolve, reject) => {
        Api.badgesList().then(res => {
          if (res) {
            let oneLevelBadges = res.one_level_badges.map(item => {
              try {
                item.data = JSON.parse(item.descr)
              } catch (e) { };
              return item
            })
            let multilevelBadges = res.multilevel_badges.map(level => {
              return level.map(item => {
                try {
                  item.data = JSON.parse(item.descr)
                } catch (e) { };
                return item
              })
            })
            commit('updateBadges', {
              oneLevelBadges,
              multilevelBadges
            })
          }
          resolve(res)
        })
      })
    },

    getGift({
      commit
    }, gift) {
      return Api.getGift(gift)
    },

    setVariable({ commit }, custom_vars) {
      return Api.setVariable(custom_vars)
    },

    checkLogin({
      commit,
      dispatch
    }) {
      return new Promise((resolve, reject) => {
        const authHash = Cookies.get(CONFIG.auth_cookie_name || DEFAULT_AUTH_COOKIE)
        commit('setAuthHash', authHash)
        if (authHash) {
          Api.login(authHash).then((user) => {
            const userInfo = dispatch('fetchUser')
            const userPosition = dispatch('fetchVars')
            const userHistory = dispatch('fetchHistory')
            const tags = dispatch('fetchTags')
            const gifts = dispatch('fetchGifts')
            const config = dispatch('fetchConfig')
            const quests = dispatch('fetchQuests')
            const p2p = dispatch('updateP2PQuest')
            const promises = [userInfo, userHistory, tags, gifts, config, quests, p2p]
            return Promise.all(promises).then(resolve, reject).then(() => {
              dispatch('changeTags', { add: ['Login'] })
              commit('ready')
            })
          }, reject)
        } else {
          reject(authHash)
        }
      })
    },

    updateP2PQuest({
      commit,
      dispatch,
      rootGetters,
      state
    }) {
      dispatch('fetchVars').then(() => {
        for (let i in state.p2pTypes) {
          let type = state.p2pTypes[i]

          let auth_hash
          if (type != 'default') {
            auth_hash = rootGetters.currentVars.find(variable => variable.name === `${type}_auth`);
            if (!auth_hash) {
              continue
            } else {
              auth_hash = auth_hash.value
            }
          } else {
            auth_hash = state.auth_hash
          }
          let load_actions = Vue.jsonp(`https://luxoft.sailplay.com/js-api/1954/actions/custom/list/?auth_hash=${auth_hash}`)
          let load_points = Vue.jsonp(`https://luxoft.sailplay.com/js-api/1954/users/info/?auth_hash=${auth_hash}`)
          let load_history = Vue.jsonp(`https://luxoft.sailplay.com/js-api/1954/users/history/?auth_hash=${auth_hash}`)
          Promise.all([load_actions, load_points, load_history])
            .then((data) => {
              let points = data[1].user_points.confirmed
              if (type == 'default' || type == 'p2p') {
                let quest = data[0].actions.find(quest => quest.type === 'points_transfer')
                if (!quest) {
                  return
                }
                if (quest.content.immediate_outbound_limit) {
                  points = Math.min(points, quest.content.immediate_outbound_limit)
                }
                if (quest.content.periodic_outbound_limit && quest.content.periodic_outbound_limit.sum) {
                  let limit_date = new Date()
                  limit_date.setDate(limit_date.getDate() - quest.content.periodic_outbound_limit.limits.length)
                  let transferredPoints = data[2].history.filter(item => item.action === 'points_transfer' && item.points_delta < 0 && new Date(item.action_date) > limit_date)
                  let limitUsed = -transferredPoints.reduce((acc, obj) => acc + obj.points_delta, 0)
                  points = Math.max(
                    Math.min(points, (quest.content.periodic_outbound_limit.sum - limitUsed)),
                    0
                  )
                }
              }
              let p2pConfig = {
                "points": points,
                "quest": data[0].actions.find(quest => quest.type === 'points_transfer'),
                "auth_hash": auth_hash,
                "type": type
              }
              commit('updateP2pConfig', p2pConfig);
            })
        }
      })
    }
  }
})
